import {
    BookSuggestedAvailabilityData,
    GetSuggestedAvailabilitiesInput,
    SuggestedAvailabilitiesService
} from "./SuggestedAvailabilities.service";
import {createErrorHandlingThunk} from "../../auth/redux/utils";
import {SuggestedAvailability} from "./types";

const suggestedAvailabilitiesService = new SuggestedAvailabilitiesService();

export const getSuggestedAvailabilitiesThunk = createErrorHandlingThunk<SuggestedAvailability[], GetSuggestedAvailabilitiesInput>(
    'suggestedAvailabilities/get',
    (args) => suggestedAvailabilitiesService.getSuggestedAvailabilities(args)
);

export const bookSuggestedAvailabilityThunk =  createErrorHandlingThunk<{ }, BookSuggestedAvailabilityData>(
    'bookSuggestedAvailability',
    (args) => suggestedAvailabilitiesService.bookSuggestedAvailability(args)
);

export const confirmOrderThunk =  createErrorHandlingThunk<{ }, { orderId: string }>(
    'confirmOrder',
    (args) => suggestedAvailabilitiesService.confirmOrder(args)
);